/*
 *  I11PERCHARVARICalcul.js
 *
 *  Created by Sébastien Hecart on 2017-12-20 15:31:49 +0000.
 *  Copyright © 2017 Sebastien Hecart. All rights reserved.
 *
 *
 */

import { I11PERCHARVARI_State } from '@batical/types/src'

function I11PERCHARVARI_docalcul(state: I11PERCHARVARI_State) {
  state.invalidated = false
  if (state.perteCharg_uuid) {
    // let selectedpdc: RPerteChargeUniteCalculSchema_Type = fetchPerteChargeUnite(state.perteCharg_uuid)
    state.res_resistanceelement = state.in_pertechargenominal / Math.pow(state.in_debitnominal, 2)
    state.res_ouvellepertecharge = state.res_resistanceelement * Math.pow(state.in_nouveaudebit, 2)
  }
  return state
}

export default I11PERCHARVARI_docalcul
